import { render } from "./SetupTardyAppointments.vue?vue&type=template&id=30166175"
import script from "./SetupTardyAppointments.vue?vue&type=script&lang=js"
export * from "./SetupTardyAppointments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__